import React from "react";
import { Query } from 'react-apollo';
import { getVoucher } from '../../../../graphql/query/voucher';
import AntSpin from "../../../common/AntSpin";
import { PageHeader, Descriptions, Tag, Button, Modal } from 'antd';

function VoucherModal({visible, setVisible, idVoucher}){

    if(idVoucher !== undefined)return (
        <Query 
            query={getVoucher}
            variables={{ _id: idVoucher }}
        >
            {({ loading, error, data, refetch }) => {

                return(
                    <Modal
                        title={`Voucher - ${idVoucher}`}
                        visible={visible}
                        width={900}
                        onOk={() => setVisible(visible = false)}
                        onCancel={() => setVisible(visible = false)}
                        style={{marginTop: -60}}
                        footer={[
                            <Button icon="check-circle" type="primary" key="back" onClick={() => setVisible(visible = false)}>
                                OK
                            </Button>
                        ]}
                    >
                        {
                            loading ? <AntSpin/> :
                                <PageHeader
                                    title={data.voucher.client_info[0].name}
                                    style={{
                                        border: '1px solid rgb(235, 237, 240)',
                                    }}
                                    //subTitle={data.voucher.client_info[0].email}
                                    tags={<Tag color="blue">{data.voucher.client_info[0].document}</Tag>}
                                    avatar={{ src: require('../../../../img/user.png') }}
                                >
                                    <Descriptions size="small" column={3}>
                                        <Descriptions.Item label="Email">{data.voucher.client_info[0].email}</Descriptions.Item>
                                        <Descriptions.Item label="Telefone">{data.voucher.client_info[0].phone}</Descriptions.Item>
                                        <Descriptions.Item label="Celular">{data.voucher.client_info[0].celphone}</Descriptions.Item>
                                    </Descriptions>
                                </PageHeader>
                        }
                    </Modal>
                )   
            }}
        </Query>
    )
    else return null
} 

export default VoucherModal;


// WEBPACK FOOTER //
// ./src/components/general/vouchersWrapper/components/VoucherModal.jsx